import * as types from "./types";

const INITIAL_STATE = {
  list: [],
  meta: {},
  searchKeyword: null,
  title: null,
  singleTest: null,
  searchInBookKeyword: null,
  testsBookIdFilter: 0,
  CanBeEditTest: true,
  bookTests: {
    list: [],
    meta: {}
  },
  singleTestReport: null,
  TestsPage: 1
};

const testsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_TESTS_RESPONSE:
      return {
        ...state,
        list: action.payload.list,
        meta: action.payload.meta
      };
    case types.GET_SINGLE_TEST_RESPONSE:
      return { ...state, singleTest: action.payload };
    case types.SET_TEST_FILTERS:
      return {
        ...state,
        searchKeyword: action.payload.searchKeyword
      };
    case types.SET_TESTS_BOOK_ID_FILTER:
      return {
        ...state,
        testsBookIdFilter: action.payload.id
      };
    case types.GET_BOOK_TEST_RESPONSE:
      return {
        ...state,
        bookTests: {
          list: action.payload.list,
          meta: action.payload.meta
        }
      };

    case types.SET_TEST_BOOK_FILTERS:
      return {
        ...state,
        searchInBookKeyword: action.payload.searchInBookKeyword
      };
    case types.GET_SINGLE_TEST_REPORT_RESPONSE:
      return { ...state, singleTestReport: action.payload };

    case types.CHECK_FOR_CAN_BE_EDIT_TEST_RESPONSE:
      return { ...state, CanBeEditTest: action.payload };
    case types.SET_TESTS_PAGES:
      return { ...state, TestsPage: action.payload.page };

    default:
      return state;
  }
};

export default testsReducer;
